import { createFileRoute } from "@tanstack/react-router";

import { Bauru } from "@/components/itv/pages/Bauru";
import { carregarPaginaSimples } from "@/lib/pagina-simples";

const PATH = "/bauru/";
const TITLE = "Consultório em Bauru: Endereço e Como Chegar | Dr. Thiago Viana";
const DESCRIPTION =
  "Consultório do Dr. Thiago Viana em Bauru, no Jardim Europa: endereço, mapa, horário e como agendar. Atendimento presencial e teleconsulta para todo o Brasil.";

export const Route = createFileRoute("/bauru")({
  loader: () => carregarPaginaSimples(PATH, TITLE, DESCRIPTION),
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  return <Bauru />;
}
